export type HeatingSourceTypesProps = {
  hasElectric: boolean;
  hasGas: boolean;
  hasHeatPump: boolean;
  hasOil: boolean;
  hasPropaneButane: boolean;
  hasSolar: boolean;
};

const HeatingSourceTypes = ({
  hasElectric = false,
  hasGas = false,
  hasHeatPump = false,
  hasOil = false,
  hasPropaneButane = false,
  hasSolar = false,
} = {}) => ({
  hasElectric: Boolean(hasElectric),
  hasGas: Boolean(hasGas),
  hasHeatPump: Boolean(hasHeatPump),
  hasOil: Boolean(hasOil),
  hasPropaneButane: Boolean(hasPropaneButane),
  hasSolar: Boolean(hasSolar),
});

export default HeatingSourceTypes;
